import useSWR from "swr";

import { fetchTutorialManifest } from "./tutorialsService";
import type { TutorialManifest } from "./types";

const TUTORIAL_MANIFEST_KEY = "tutorials-manifest";

export const useTutorialManifest = () => {
  const { data, error, isLoading } = useSWR<TutorialManifest>(
    TUTORIAL_MANIFEST_KEY,
    fetchTutorialManifest,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: true,
      errorRetryCount: 2,
      dedupingInterval: 300000,
    }
  );

  return {
    manifest: data,
    isLoading,
    isError: error,
  };
};
